import {
  getMigrationStates,
  isTenantSyncManagedError,
  listTenants,
  readsFromErebus,
  TENANT_ENTITY,
} from '@erebus/http';
import { api } from 'boot/axios';

/** One row of Connect's client list. Screens only use these two fields. */
export interface ClientListItem {
  clientID: number;
  clientName: string;
}

/** Reads the list from where the tenant migration state points right now. */
async function readOnce(): Promise<ClientListItem[]> {
  const states = await getMigrationStates();
  if (!readsFromErebus(states, TENANT_ENTITY)) {
    const response = await api.get('api/v1/clients');
    return response.data;
  }
  const tenants = await listTenants({ status: 'active' });
  return tenants.map((t) => ({ clientID: t.legacyClientId, clientName: t.name }));
}

/**
 * Loads the client list from legacy or Erebus, based on the tenant migration
 * state. The state is fetched fresh on every call.
 *
 * A 409 `sync_managed` means the state changed under us (for example, rolled
 * back to syncing). Then we reload the state once and read again. Any other
 * error, or a second 409, rejects. There is no fallback to legacy on error.
 */
export async function loadClientList(): Promise<ClientListItem[]> {
  try {
    return await readOnce();
  } catch (err) {
    if (!isTenantSyncManagedError(err)) throw err;
    return readOnce();
  }
}
